<template>
	<div></div>
</template>

<script>
export default {
	name: "HorizontalDivider",
};
</script>

<style scoped>
div {
	width: 100%;
	height: 3px;
	background-color: var(--primary);
	margin: 2rem 0;
}
</style>
